module.exports = __webpack_public_path__ + "img/oblique2.23c118f9.jpg";